import CityPageTemplate from "../city-template/CityPageTemplate";
import { roundRockConfig } from "./data";

export default function RoundRockPage() {
  return <CityPageTemplate config={roundRockConfig} />;
}